import { useMemo, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { Box, Group, Image, Stack, Stepper } from "@mantine/core";
import BackButton from "../../../../components/View/BackButton";
import OvhStep1 from "./OvhStep1";
import OvhStep2 from "./OvhStep2";
import OvhStep3 from "./OvhStep3";
import OvhStep4 from "./OvhStep4";
import OvhStepFinished from "./OvhStepFinished";
import { useSessionStore } from "../../../../stores/UserStore";
import IframeWithPlaceholder from "../../../../components/View/IframeWithPlaceholder";
import thumbnail from "../../../../assets/ovh-cover.jpg";
import VideoModalViewer from "../../../../components/View/VideoModalViewer";
import { getYouTubeMaxThumbnail } from "../../../../functions/utilFunctions";
import { PlayIcon } from "../../../../components/Icons/SvgIcons";

const OvhContent = ({ handleClose, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const [activeStep, setActiveStep] = useState(0);
  const [apiKey, setApiKey] = useState(null);
  const [domain, setDomain] = useState(null);
  const [emails, setEmails] = useState([]);
  const [buyDomain, setBuyDomain] = useState(true);
  const [domainSearch, setDomainSearch] = useState("");
  const [details, setDetails] = useState({
    currencyCode: null,
    domainPrice: null,
  });

  const resellerVideo = reseller?.videos?.find(
    (x) => x.name === "IntegrationOVHTutorial"
  );

  const actualStep = useMemo(() => {
    if (activeStep === 0) {
      return (
        <OvhStep1
          setActiveStep={setActiveStep}
          apiKey={apiKey}
          setApiKey={setApiKey}
        />
      );
    }
    if (activeStep === 1) {
      return (
        <OvhStep2
          setActiveStep={setActiveStep}
          apiKey={apiKey}
          domain={domain}
          details={details}
          setDetails={setDetails}
          setDomain={setDomain}
          buyDomain={buyDomain}
          setBuyDomain={setBuyDomain}
          domainSearch={domainSearch}
          setDomainSearch={setDomainSearch}
        />
      );
    }
    if (activeStep === 2) {
      return (
        <OvhStep3
          setActiveStep={setActiveStep}
          domain={domain}
          emails={emails}
          setEmails={setEmails}
          buyDomain={buyDomain}
        />
      );
    }
    if (activeStep === 3) {
      return (
        <OvhStep4
          setActiveStep={setActiveStep}
          domain={domain}
          emails={emails}
          apiKey={apiKey}
          buyDomain={buyDomain}
          details={details}
        />
      );
    }
    return "";
  }, [activeStep, apiKey, buyDomain, domain, emails, domainSearch, details]);

  return (
    <div style={{ padding: "0 16px" }}>
      <Stepper active={activeStep} color="primary">
        <Stepper.Step
          label={lang.ovh.step1_title}
          description={lang.ovh.step1_desc}
        />
        <Stepper.Step
          label={lang.ovh.step2_title}
          description={lang.ovh.step2_desc}
        />
        <Stepper.Step
          label={lang.ovh.step3_title}
          description={lang.ovh.step3_desc}
        />
        <Stepper.Step
          label={lang.ovh.step4_title}
          description={lang.ovh.step4_desc}
        />
      </Stepper>

      {activeStep < 4 ? (
        <Group align="start" gap={64} mt={20}>
          <Stack
            flex={1}
            maw={
              useSessionStore.getState().reseller?.name === "Magileads"
                ? 640
                : "none"
            }
            mih={455}
          >
            {actualStep}
          </Stack>
          {reseller?.name === "Magileads" ? (
            <IframeWithPlaceholder
              videoId={"1nYgguJyqog"}
              thumbnail={thumbnail}
            />
          ) : resellerVideo ? (
            <VideoModalViewer
              src={resellerVideo.url}
              opener={(handleOpen) => (
                <Stack
                  ml="auto"
                  flex={1}
                  style={{ position: "relative", cursor: "pointer" }}
                  align="end"
                  onClick={handleOpen}
                >
                  <PlayIcon
                    variant="light"
                    color="#fcfbff"
                    size={64}
                    iconSize={32}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 10,
                    }}
                    radius={64}
                    className="play-button"
                  />

                  {resellerVideo?.url.includes("youtube") || resellerVideo?.thumbnail_url ? (
                    <Image
                      src={getYouTubeMaxThumbnail(resellerVideo?.url, "IntegrationOVHTutorial")}
                      style={{ borderRadius: 12, height: "100%" }}
                    />
                  ) : (
                    <video
                      src={resellerVideo?.url}
                      className="reseller-video"
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "block",
                      }}
                    />
                  )}
                </Stack>
              )}
            />
          ) : (
            ""
          )}
        </Group>
      ) : (
        <OvhStepFinished
          domain={domain}
          emails={emails}
          buyDomain={buyDomain}
          onFinish={onFinish}
          handleClose={handleClose}
        />
      )}

      {activeStep !== 4 && (
        <Group justify="end" mt={"lg"}>
          <BackButton size="md" onClick={handleClose} />
        </Group>
      )}
    </div>
  );
};

export default OvhContent;
